var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.61 7.56a.55.55 0 0 1 .78 0l2.05 2.05a.55.55 0 0 1 0 .78l-2.05 2.05a.55.55 0 1 1-.78-.78L11.273 10 9.61 8.34a.55.55 0 0 1 0-.78",
  clipRule: "evenodd"
})));
export default SvgCaretSmall;